"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileStat = void 0;
var time_conversion_1 = require("../utilities/time-conversion");
var i18next_1 = __importDefault(require("i18next"));
var ProfileStat = /** @class */ (function () {
    function ProfileStat(title, value) {
        this.title = title;
        this.value = value;
    }
    return ProfileStat;
}());
exports.ProfileStat = ProfileStat;
var Profile = /** @class */ (function () {
    function Profile() {
    }
    Profile.Stats = function (dragon) {
        return [
            {
                title: i18next_1.default.t("time_since_quit"),
                value: (0, time_conversion_1.timeConversion)(Date.now() - dragon.quit.start.getTime())
            },
            {
                title: i18next_1.default.t("previously_smoked"),
                value: i18next_1.default.t("number_per_day").replace("[number]", String(dragon.quit.dailyCigarettes.toFixed()))
            },
            {
                title: i18next_1.default.t("items_unlocked"),
                value: this.Count(dragon.unlocks).toFixed()
            },
            {
                title: i18next_1.default.t("missions_completed"),
                value: dragon.achievements.missionsCompleted.toFixed()
            },
            {
                title: i18next_1.default.t("diaries_recorded"),
                value: dragon.achievements.diariesRecorded.toFixed()
            },
            {
                title: i18next_1.default.t("cravings_recorded"),
                value: dragon.achievements.cravingsRecorded.toFixed()
            },
            {
                title: i18next_1.default.t("wishlist_items"),
                value: dragon.achievements.wishlistItemsAdded.toFixed()
            },
            {
                title: i18next_1.default.t("tips_favourited"),
                value: dragon.achievements.tipsFavourited.toFixed()
            }
        ];
    };
    Profile.Count = function (unlocks) {
        var e_1, _a, e_2, _b;
        var count = 0;
        try {
            for (var _c = __values(Object.keys(unlocks)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var categoryID = _d.value;
                // Ignore categories unlocked by default
                if (categoryID == "body" || categoryID == "eyes") {
                    continue;
                }
                try {
                    for (var _e = (e_2 = void 0, __values(unlocks[categoryID])), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var elementID = _f.value;
                        // Ignore elements unlocked by default
                        if (elementID == "none") {
                            continue;
                        }
                        count += 1;
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return count;
    };
    return Profile;
}());
exports.default = Profile;
